var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { makeObservable } from 'mobx';
import { sortedSet } from '../../../utils/mobx/decorators/customComputed';
export class SortableLists {
    parent;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    get question() {
        return this.parent;
    }
    get unassignedItems() {
        return this.question.sortableStore.sortableItems.filter(sortableItem => !this.question.sortableStore.sortableLists.map(list => list.id_string).includes(sortableItem.droppableId));
    }
    getListById(id) {
        return this.question.sortableStore.sortableLists.find(sortableList => sortableList.id_string === id);
    }
    solidListById(id) {
        return this.getListById(id);
    }
}
__decorate([
    sortedSet
], SortableLists.prototype, "unassignedItems", null);
